import Box from '@mui/material/Box';

import { UserRolesFormControl } from '../../../UserRoles';

interface Props {
  readonly id: string;
}

// eslint-disable-next-line no-empty-pattern
export const UserRolesFormStep = ({}: Readonly<Props>) => (
  <Box sx={{ pt: 1 }}>
    <UserRolesFormControl
      fallbackRoleIds={null}
      name="globalRoleIds"
      required
      scope="global"
    />
  </Box>
);
